import VueRouter from "vue-router";
const Login = () => import("@/components/pages/Login.vue");
const Forbidden = () => import("@/components/pages/Forbidden.vue");
const Dashboard = () => import("@/components/pages/Dashboard.vue");
// const Exposure = () => import("@/components/pages/Exposure.vue");
const ExposureTest = () => import("@/components/pages/Exposure.vue");
const Position = () => import("@/components/pages/Position.vue");
const Suppression = () => import("@/components/pages/Suppression.vue");
const Contest = () => import("@/components/pages/Contest.vue");
const Focus = () => import("@/components/pages/Focus.vue");
const SettingUser = () => import("@/components/pages/settings/User.vue");
const TheContainer = () => import("@/components/layouts/Dashboard.vue");
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken, removeToken } from "@/utils/auth";
import store from "../store";

const whiteList = ["/login", "/auth-redirect"];

const routes = [
  {
    path: "/",
    redirect: "/exposure",
    name: "Home",
    component: TheContainer,
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          title: "Dashboard",
        }
      },
      {
        path: "exposure",
        name: "Exposure",
        component: ExposureTest,
        meta: {
          title: "Exposure"
        }
      },

      {
        path: "suppressions",
        name: "Suppression",
        component: Suppression,
        meta: {
          title: "Manage Suppression Accounts",
          roles: ['admin']
        }
      },
      {
        path: "contest",
        name: "Contest",
        component: Contest,
        meta: {
          title: "Manage Contest",
          roles: ['admin', 'operator']
        }
      },
      {
        path: "focus",
        name: "Focus",
        component: Focus,
        meta: {
          title: "Focus Watch List",
          roles: ['admin']
        }
      },
      {
        path: "position",
        name: "Position",
        component: Position,
        meta: {
          title: "Position (TEST)",
          roles: ['admin']
        }
      },
      {
        path: "settings/users",
        name: "SettingUser",
        component: SettingUser,
        meta: {
          title: "User Management",
          roles: ['admin']
        }
      }
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "Login"
    }
  },
  {
    path: "/forbidden",
    name: "Forbidden",
    component: Forbidden,
    meta: {
      title: "Forbidden"
    }
  }
];

const router = new VueRouter({
  routes,
  // mode: "history"
});

// This callback runs before every route change, including on page load.
router.beforeEach(async (to, from, next) => {
  // Start Progress Bar
  NProgress.start();

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Check if has token
  const token = getToken();

  if (token) {
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({ path: "/dashboard" });
      NProgress.done();
    } else {
      // Check if user data is exist
      if (!store.getters.name) {
        try {
          await store.dispatch("user/getInfo");
        }
        catch (err) {
          if (err.response.status == 403) {
            localStorage.clear()
          }
        }

      }
      // Check route permissions
      if('roles' in to.meta && !to.meta.roles.includes(store.getters.role)) {
        next("/forbidden");
      }

    }
  } else {
    // Redirect to Login Page
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }

  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});
export default router;
